// add correct formId and formVersionId
document.addEventListener('DOMContentLoaded', function() {
    console.log('adding klaviyo watcher')
    window.addEventListener("klaviyoForms", function(e) {
      console.log(e);
      if(e.detail.formId === 'WDHXp7') {
        if(e.detail.type === "stepSubmit") {
          document.cookie = `discount_code=FREESHIP; path=/; samesite=lax`;
          console.log("FREESHIP discount applied")
        }
      }
      if(e.detail.formId === 'Yx6Xzk') {
        if(e.detail.type === "submit" && !window.Yx6Xzksubmitted) {
          
          const d = new Date();
          d.setTime(d.getTime() + (1*1*60*60*1000));
          const expires = "expires="+ d.toUTCString();
          document.cookie = `freeship_countdown=${d.getTime()}; ${expires}; path=/; samesite=lax`;
          document.cookie = `discount_code=FREESHIP; ${expires}; path=/; samesite=lax`;
          console.log("FREESHIP discount applied");
          window.Yx6Xzksubmitted = true;
          // add sticky
          setFreeShipCountdown(d);
        }
      }
    });
    if(typeof window.tippy === 'function') {
      window.tippy(document.querySelectorAll('.choose-fragrance'), {
        content: '💧<strong>Fragrance Free:</strong> No added fragrance. Perfect for sensitive skin.<br><br>🌸<strong>Spring Blossom:</strong> Smells like a beautiful floral bouquet from the garden.<br><br>⛰️<strong>Frosty Mountain:</strong> Smells like fresh air at the peak of a snowy mountain.<br>',
        allowHTML: true,
      })
    }
      window.tippy(document.querySelectorAll('.choose-fragrance--multipurpose'), {
        content: '🍋🌿<strong>Golden Spritz:</strong> An uplifting blend of lemongrass and basil that leaves your home smelling fresh and clean.<br><br>💧<strong>Fragrance Free:</strong> No added fragrance. Perfect for sensitive skin.',
        allowHTML: true,
      })
})



function getTimeLeft(timestamp) {
  const now = new Date();
  const timeLeft = timestamp - now;

  if (timeLeft < 0) {
    return 'Time has passed';
  }

  const seconds = Math.floor(timeLeft / 1000) % 60;
  const minutes = Math.floor(timeLeft / (1000 * 60)) % 60;
  const hours = Math.floor(timeLeft / (1000 * 60 * 60));

  return `${minutes}m : ${seconds}s`;
}

function renderFreeshipCountdown() {
  const countdownElement = document.getElementById('sticky-button__countdown');
  if(!window.freeShipCountdownEnd || !countdownElement) {
    return;
  }
  setTimeout(() => {countdownElement.style.display = 'block';}, 1000);
  let timerId = setInterval(() => {
    if (Date.now() >= window.freeShipCountdownEnd) {
      clearInterval(timerId);
      countdownElement.style.display = 'none';
      return;
    }

    const timeleftText = getTimeLeft(window.freeShipCountdownEnd);
    countdownElement.innerHTML = `<span class='sticky-button__countdown-voucher'>Free Shipping</span><span>reserved for</span><span>${timeleftText}</span>`;
  }, 1000); // Update countdownElement textContent every second (1000 milliseconds)
}

function setFreeShipCountdown(expires = undefined) {
  const cookieArray = /(freeship_countdown=)(\d+)/.exec(document.cookie);
  if(expires) {
    
  } else if(!cookieArray) {
    console.log('no freeshipcookie')
    return;
  } else if(cookieArray && cookieArray.length > 2) {
    expires = cookieArray[2];
  } else {
    return;
  }
  console.log(expires);
  window.freeShipCountdownEnd = expires;
  renderFreeshipCountdown();
  
}

setFreeShipCountdown();

var purchase_types = document.querySelectorAll('.sc_radio[name="purchase_type"]');
for (var i = 0; i < purchase_types.length; i++) {
    purchase_types[i].addEventListener('change', function() {
      if(this.value == "onetime"){
        
        var sellonetime = document.getElementById("selling_plan_onetime");
        sellonetime.checked = true;
      }else if(this.value == "autodeliver"){
        document.querySelector('.sc_delivery-radio[name="selling_plan"][value]:not([value=""])').checked = true;
        
        // var onepack = document.querySelector('.sc_pack-radio[name="Pack"][value="1"]');
        // onepack.checked = true;
      }
    });
}


var rad = document.querySelectorAll(".sc_pack-radio");
for (var i = 0; i < rad.length; i++) {
    rad[i].addEventListener('change', function() {

      // var label = document.querySelector('label[for=' + this.id + ']');
      var parent = this.closest(".sc_pack-option");
      this.closest(".sc_info-content").querySelector('.sc_price').innerHTML = parent.dataset.price;
      this.closest(".sc_info").querySelector('.sc_info-title .sc_price').innerHTML = parent.dataset.price;
      if(parent.dataset.saving){
        this.closest(".sc_info-content").querySelector('.sc_total-savings').innerHTML = "You save <p class='sc_savings-price'>" + parent.dataset.saving + "</p>";
      this.closest(".sc_info-content").querySelector('.sc_compared-price').innerHTML = parent.dataset.cprice;
      }else {
        this.closest(".sc_info-content").querySelector('.sc_total-savings').innerHTML = "Choose more than 1 Pack to Save";
      this.closest(".sc_info-content").querySelector('.sc_compared-price').innerHTML = "";
      }
      this.closest(".sc_info-content").querySelector('.sc_price-perpack').innerHTML = parent.dataset.perprice;
    });
}

var delivery_options = document.querySelectorAll('.sc_delivery-radio[name="selling_plan"]');
for (var i = 0; i < delivery_options.length; i++) {
    delivery_options[i].addEventListener('change', function() {

      document.querySelector(".frequency-modal__button.is_active").classList.remove("is_active");
      document.querySelector('.frequency-modal__button[data-frequency*="' + this.dataset.frequency + '"]').classList.add("is_active");
      this.closest(".sc_info-block").querySelector('.sc_delivery-frequency').innerHTML = this.dataset.frequency;
    });
}

// var buttons = document.querySelectorAll(".sc_delivery-option");
// for (var i = 0; i < buttons.length; i++) {
//     buttons[i].addEventListener('click', function() {
//       // const input = document.querySelector('input[name="id"]');
//       // input.value = this.dataset.id;
//       var vid = this.dataset.id;
//       this.closest(".sc_delivery-options").querySelector('.is_active').classList.remove("is_active");
//       this.classList.add("is_active");

//       document.querySelector(".frequency-modal__button.is_active").classList.remove("is_active");
//       document.querySelector('.frequency-modal__button[data-frequency*="' + this.dataset.frequency + '"]').classList.add("is_active");
//       this.closest(".sc_info-block").querySelector('.sc_delivery-frequency').innerHTML = this.innerHTML;
      
//       const productForms = document.querySelectorAll(`#product-form-template--15855377154200__main, #product-form-installment-template--15855377154200__main`);
//       productForms.forEach((productForm) => {
//         const input = productForm.querySelector('input[name="id"]');
//         input.value = vid;
//         console.log("vid", vid);
//       });
//     });
// }

var modal_buttons = document.querySelectorAll(".frequency-modal__button");
for (var i = 0; i < modal_buttons.length; i++) {
    modal_buttons[i].addEventListener('click', function(e) {
      e.preventDefault()

      // this.closest(".frequency-modal__options").querySelector('.is_active').classList.remove("is_active");
      // this.classList.add("is_active");

      document.querySelector('.sc_delivery-radio[data-frequency*="' + this.dataset.frequency + '"]').click();
    });
}

function updateDiscountDate() {
  let discountBanner = document.querySelector('.discount-code');
  if(document.querySelector('.discount-banner')) {
    discountBanner = document.querySelector('.discount-banner');
  }

  if(discountBanner) {
    const d = new Date();
  
    const options = {
        month: 'short',
        day: 'numeric',
    };
    if(d.getMonth() === 5 || d.getMonth() === 6) {
        options.month = 'long';
    }
  
    discountBanner.innerHTML = discountBanner.innerHTML.replace(/expires[a-z0-9 ]+\./i, `EXPIRES ${d.toLocaleDateString('en-US', options).toUpperCase()}.`);
  }
}
updateDiscountDate();
setTimeout(() => {
  updateDiscountDate()
},0);
setTimeout(() => {
  updateDiscountDate()
},100);
setTimeout(() => {
  updateDiscountDate()
},1000);
